import * as React from 'react';
import { clsx } from 'clsx';
import { ArrowL24, ArrowR24 } from '@cian/ui-kit/prev';

import * as styles from '../../styles/button.css';

interface IButtonProps {
  right?: boolean;
  onClick(e: React.MouseEvent): void;
}

export const ScrollButton: React.FC<IButtonProps> = ({ onClick, right }) => {
  return (
    <button
      className={clsx(styles['button'], right ? styles['button-right'] : styles['button-left'])}
      onClick={onClick}
      tabIndex={-1}
    >
      {right ? <ArrowR24 /> : <ArrowL24 />}
    </button>
  );
};
